<app-view-title [isSoftSplit]="true"></app-view-title>
<view-content [centered]="true">
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.StowLock.LockOpenTitle' | translate : 'The lock is open!' }}</h2>
    <p>{{ 'Intellitrailer.Rental.StowLock.LockOpenInstructions' | translate : 'The padlock is now unlocked and you can now remove the cover from the tow ball hitch. Please bring both the padlock and the cover with you.' }}</p>
    <p>{{ 'Intellitrailer.Rental.StowLock.CloseLockInstructions' | translate : 'Remember to close the lock when storing it.' }}</p>
  </app-card>
</view-content>
<view-actions mode="white">
  <button mat-raised-button (click)="next()">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
</view-actions>

